import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    CONVERSATIONS_UPDATE,
    UPDATE_CONTACT,
    CONVERSATIONS_EMPLOYEE_BAN,
    CONVERSATIONS_EMPLOYEE_UNBAN,
} from "actions/type";
import { setNewMessage, setUnreadCount } from "store/message/newMessage";
import { removeNotifications } from "actions/removeNotifications";

const ChatNotifications = () => {
    const notifications = useSelector((state) => state.notifications.items);
    const conversations = useSelector((state) => state.conversations.items);
    const userId = useSelector((state) => state.profile.profileData.id);
    const dispatch = useDispatch();

    useEffect(() => {
        if (notifications.length && userId) {
            const item = notifications[notifications.length - 1];

            if (item?.type === "last_message" || item?.type === "conversation_create") {
                dispatch({
                    type: CONVERSATIONS_UPDATE,
                    payload: notifications[notifications.length - 1],
                });
                dispatch({
                    type: UPDATE_CONTACT,
                    payload: notifications[notifications.length - 1],
                });
                if (userId !== item.last_message?.from_user_id) {
                    dispatch(setNewMessage({ isSeen: false }));
                }
            } else if (item?.type === "isSeen") {
                dispatch(setNewMessage({ isSeen: item.isSeen }));
            } else if (item?.status) {
                dispatch(setNewMessage({ isSeen: false }));
            } else if (item?.type === "block") {
                dispatch({ type: CONVERSATIONS_EMPLOYEE_BAN, payload: { id: item.id } });
            } else if (item?.type === "unblock") {
                dispatch({ type: CONVERSATIONS_EMPLOYEE_UNBAN, payload: { id: item.id } });
            }
            dispatch(removeNotifications());
        }
    }, [notifications, dispatch, userId]);

    useEffect(() => {
        const unreadCount = conversations.filter((conv) => conv.is_seen === false).length;
        dispatch(setUnreadCount(unreadCount));
    }, [conversations, dispatch]);

    return <></>;
};

export default ChatNotifications;
